import { createSlice } from '@reduxjs/toolkit';


const filterSlice = createSlice({
  name: 'filters',
  initialState: {},
  reducers: {
    setFilters: (_, { payload }) => {
      return payload;
    },
    removeFilters: () => {
      return {};
    }
  }
});

export const { setFilters, removeFilters } = filterSlice.actions;
export default filterSlice;
